import { installFetchLogging } from '@maestro/core/logger/fetch-logger'
import { overrideConsoleLogger } from '@maestro/core/logger/json-console-logger'

export const enableJsonLogger = () => {
  overrideConsoleLogger()
  installFetchLogging()
}
